import { NgModule, Pipe, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { IonicModule, IonicRouteStrategy, Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { SidenavigationComponent } from 'src/sidenavigation/sidenavigation.component';
import { CommonDeclarationService } from './service/common/common-declaration.service';
import { HttpClientModule } from '@angular/common/http';
import { LoginComponent } from 'src/modules/login/login.component';
import { PreregisterComponent } from 'src/modules/preregister/preregister.component';
import { ExistingCustomerComponent } from 'src/modules/existingCustomer/existingCustomer.component';
import { LanguageComponent } from 'src/modules/language/language.component';
import { Network } from '@ionic-native/network/ngx';
import { HeaderComponent } from 'src/header/header.component';
import { GuidedTourComponent } from 'src/modules/guided-tour/guided-tour.component';
import { Device } from '@ionic-native/device/ngx';
import { NetworkInterface } from '@ionic-native/network-interface/ngx';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlphabetsWithoutSpace } from './directives/alphabetsonly/alphabetsonly.directive';
import { AlphabetswithspaceDirective } from './directives/alphabetswithspace/alphabetswithspace.directive';
import { VaChatPage } from './va/va-chat/va-chat.page';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { ProspectUserComponent } from 'src/modules/prospectuser/prospectuser.component';
import { VerifyOtpComponent } from 'src/modules/verifyOtp/verifyOtp.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { ConfirmRegisterComponent } from 'src/modules/confirmregister/confirmregister.component';
import { OnlynumberDirective } from './directives/numbersonly/numbersonly.directive';
import { ForgotpasswordComponent } from 'src/modules/forgotpassword/forgotpassword.component';
import { AvoidspaceDirective } from './directives/avoidSpace/avoidspace.directive';
import { AvoidotherlangDirective } from './directives/avoidotherlang/avoidotherlang.directive';
import { ChangepasswordComponent } from 'src/modules/changePassword/changePassword.component';
import { PopoverComponent } from './popover/popover.component';
import { Clipboard } from '@ionic-native/clipboard/ngx';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { HTTP } from '@ionic-native/http/ngx';
import { FaqsPage } from './va/faqs/faqs.page';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { IonicGestureConfig } from "../app/directives/gestures/ionic-gesture-config";
import 'hammerjs';
import { AboutPage } from './va/about/about.page';
import { StarredPage } from './va/starred/starred.page';
import { SettingPage } from './va/setting/setting.page';
import { ProfilePage } from './va/profile/profile.page';
import { Dialogs } from '@ionic-native/dialogs/ngx';
import { PopupconfigPage } from './va/popupconfig/popupconfig.page';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { EmailchatPage } from './va/emailchat/emailchat.page';
import { BankformComponent } from 'src/modules/bankform/bankform.component';
import { HowtousePage } from './va/howtouse/howtouse.page';
import { File } from '@ionic-native/file/ngx';
import { FilePath } from '@ionic-native/file-path/ngx';
import { FileChooser } from '@ionic-native/file-chooser/ngx';
import { DocumentDownload } from 'src/modules/documentdownload/documentdownload.component';
import { AadharUpdateComponent } from './va/aadharupdate/aadharupdate.component';
import { VasdetailsComponent } from './va/vasdetails/vasdetails.component';
import { PanUpdateComponent } from './va/panupdate/panupdate.component';
import { AddressUpdateComponent } from './va/addressupdate/addressupdate.component';
import { TextToSpeech } from '@ionic-native/text-to-speech/ngx';
import { SpeechRecognition } from '@ionic-native/speech-recognition/ngx';
import { MobileupdatePage } from './va/mobileupdate/mobileupdate.page';
import { EmailupdatePage } from './va/emailupdate/emailupdate.page';
import { Base64 } from '@ionic-native/base64/ngx';
import { Push, PushObject, PushOptions } from '@ionic-native/push/ngx';
import { CountryListModal } from './va/countrylistModal/countrylistModal.component';
import { FeedbackModal } from './va/feedbackModal/feedbackModal.component';
import { NomineePage } from './va/nominee/nominee.page';
import { DatePicker } from '@ionic-native/date-picker/ngx';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { IOSFilePicker } from '@ionic-native/file-picker/ngx';
import { FreezeComponent } from '../modules/freezescreen/freezescreen.component';
import { Safe } from "./safehtml.pipe";
import { HighlightifyPipe } from './highlightify.pipe';
import { Facebook, FacebookLoginResponse } from '@ionic-native/facebook/ngx';
import { Confightml } from "./confightml.pipe";
import { AlphabetswithspecialDirective } from "./directives/alphabetsallowed/alphabetswithspecial.directive"
import { DecimalPointsDirective } from "./directives/decimalPoints/decimalPoints.directive";
// import { TwitterConnect } from '@ionic-native/twitter-connect/ngx';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { ChangeFrequency } from './va/changefrequency/changefrequency.component';
import { IonicStorageModule } from '@ionic/storage';
import { ChangeDOB } from './va/changedob/changedob.component';
import { UpdatenamePage } from './va/updatename/updatename.page';
import { UpdateappointeePage } from './va/updateappointee/updateappointee.page';
import { PagenotfoundComponent } from 'src/modules/pagenotfound/pagenotfound.component';
import { ClaimstatusComponent } from 'src/modules/claimstatus/claimstatus.component';
import { LinkpolicyComponent } from './va/linkpolicy/linkpolicy.component';
import { VideolistComponent } from './va/videolist/videolist.component';
import { DigitalcertificateComponent } from './va/digitalcertificate/digitalcertificate.component';
import { NotificationsComponent } from './va/notifications/notifications.component';
import { ConsentpageComponent } from './va/consentpage/consentpage.component';
import { Screenshot } from '@ionic-native/screenshot/ngx';
import { VasfaqPage } from './va/vasfaq/vasfaq.page';
import {Idle, NgIdleModule } from 'ng2-idle-core';
import { IonicRatingModule } from 'ionic-emoji-rating';
//demo
// import { StreamingMedia } from '@ionic-native/streaming-media/ngx';

@NgModule({
  declarations: [
    AppComponent,
    VaChatPage,
    LoginComponent,
    PreregisterComponent,
    ExistingCustomerComponent,
    SidenavigationComponent,
    LanguageComponent,
    HeaderComponent,
    GuidedTourComponent,
    AlphabetsWithoutSpace,
    AlphabetswithspaceDirective,
    ProspectUserComponent,
    VerifyOtpComponent,
    ConfirmRegisterComponent,
    OnlynumberDirective,
    ForgotpasswordComponent,
    AvoidspaceDirective,
    AvoidotherlangDirective,
    AlphabetswithspecialDirective,
    DecimalPointsDirective,
    ChangepasswordComponent,
    PopoverComponent,
    FaqsPage,
    AboutPage,
    StarredPage,
    SettingPage,
    ProfilePage,
    PopupconfigPage,
    EmailchatPage,
    BankformComponent,
    DocumentDownload,
    AadharUpdateComponent,
    VasdetailsComponent,
    PanUpdateComponent,
    AddressUpdateComponent,
    MobileupdatePage,
    EmailupdatePage,
    HowtousePage,
    CountryListModal,
    FeedbackModal,
    NomineePage,
    FreezeComponent,
    HighlightifyPipe,
    Safe,
    Confightml,
    ChangeFrequency,
    ChangeDOB,
    UpdatenamePage,
    UpdateappointeePage,
    PagenotfoundComponent,
    LinkpolicyComponent,
    ClaimstatusComponent,
    VideolistComponent,
    DigitalcertificateComponent,
    NotificationsComponent,
    ConsentpageComponent,
    VasfaqPage
  ],
  entryComponents: [
    AppComponent,
    PopoverComponent
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot({
      name: '_khushi',
      driverOrder: ['indexeddb', 'sqlite', 'websql']
    }),
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    IonicRatingModule,
    ReactiveFormsModule,
    NgOtpInputModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    NgIdleModule.forRoot()
  ],
  providers: [
    StatusBar,
    // SplashScreen,
    Network,
    Device,
    NetworkInterface,
    InAppBrowser,
    Clipboard,
    HTTP,
    Dialogs,
    Geolocation,
    Camera,
    File,
    FilePath,
    FileChooser,
    FileOpener,
    TextToSpeech,
    SpeechRecognition,
    Base64,
    Push,
    Pipe,
    DatePicker,
    IOSFilePicker,
    Facebook,
    Screenshot,
    // StreamingMedia,
    // TwitterConnect,
    ScreenOrientation,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HAMMER_GESTURE_CONFIG, useClass: IonicGestureConfig },
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
  constructor(public platform: Platform, public cmndefnation: CommonDeclarationService) {
    if (this.platform.is('android')) {
      this.cmndefnation.runPlatform = 'android';
      this.cmndefnation.channelId = "1";
    }
    else if (this.platform.is('ios')) {
      this.cmndefnation.runPlatform = 'ios';
      this.cmndefnation.channelId = "2";
    } else if (this.platform.is('mobileweb')) {
      this.cmndefnation.runPlatform = 'mobileweb';
      this.cmndefnation.channelId = "3";
    }
  }
}